import React, { useEffect } from "react";
import { useDebouncedState } from "../../../../../utilities/hooks/useDebouncedState";
import { InputSearch } from "../../../../../boxes/InputSearch/InputSearch";

export const PaperworkSearchInput = ({ onSearch }) => {
  const [state, debouncedState, setState] = useDebouncedState();

  useEffect(() => {
    onSearch(debouncedState);
  }, [debouncedState]);

  return <InputSearch value={state} onChange={setState} />;
};
